import { AnalyticsEvent } from "../models";

export class PceLandingPageLoadEvent implements AnalyticsEvent {
  name = 'PceLandingPageLoadEvent';

  constructor() { }
}